import React, { FC, useState, useMemo, useEffect } from "react";
import { ALL_PACKEGES } from "./contants";
import { PackegeItem } from "./PackegeItem";
import { IOptionSelect } from "src/@types/form";
import { useGetFOPPackagesQuery, useGetLegalEntityPackagesQuery } from "src/redux/api";
import { IPackege } from "./types";

interface Props {
  selectOption: IOptionSelect;
}

const getImageClassForName = (name: string, type: "individual-entrepreneur" | "legal-entity"): string => {
  const nameLower = name.toLowerCase();
  
  if (nameLower.includes("light") || nameLower.includes("ligth")) {
    return type === "individual-entrepreneur" 
      ? "bg-ligth-packege-individual-entrepreneur"
      : "bg-ligth-packege-legal-entity";
  }
  if (nameLower.includes("medium")) {
    return type === "individual-entrepreneur"
      ? "bg-medium-packege-individual-entrepreneur"
      : "bg-medium-packege-legal-entity";
  }
  if (nameLower.includes("large")) {
    return type === "individual-entrepreneur"
      ? "bg-large-packege-individual-entrepreneur"
      : "bg-large-packege-legal-entity";
  }
  
  return type === "individual-entrepreneur" 
    ? "bg-ligth-packege-individual-entrepreneur"
    : "bg-ligth-packege-legal-entity";
};

export const Packeges: FC<Props> = ({ selectOption }) => {
  const { data: fopPackages, isLoading: isLoadingFOP } = useGetFOPPackagesQuery();
  const { data: legalEntityPackages, isLoading: isLoadingLegalEntity } = useGetLegalEntityPackagesQuery();
  
  const fopPackagesMapped = useMemo<IPackege[]>(() => {
    if (!fopPackages) return [];
    
    return fopPackages.map((pkg) => ({
      id: pkg.id,
      name: pkg.name,
      content: pkg.content,
      price: pkg.price,
      image: getImageClassForName(pkg.name, "individual-entrepreneur"),
    }));
  }, [fopPackages]);

  const legalEntityPackagesMapped = useMemo<IPackege[]>(() => {
    if (!legalEntityPackages) return [];
    
    return legalEntityPackages.map((pkg) => ({
      id: pkg.id,
      name: pkg.name,
      content: pkg.content,
      price: pkg.price,
      image: getImageClassForName(pkg.name, "legal-entity"),
    }));
  }, [legalEntityPackages]);

  const [selectedPackageName, setSelectedPackageName] = useState<string>("");

  useEffect(() => {
    if (selectOption.value === "individual-entrepreneur") {
      const packages = fopPackagesMapped.length > 0 
        ? fopPackagesMapped 
        : ALL_PACKEGES.INDIVIDUAL_ENTREPRENEUR;
      setSelectedPackageName(packages[0]?.name || "");
    } else {
      const packages = legalEntityPackagesMapped.length > 0
        ? legalEntityPackagesMapped
        : ALL_PACKEGES.LEGAL_ENTITY;
      setSelectedPackageName(packages[0]?.name || "");
    }
  }, [selectOption.value, fopPackagesMapped, legalEntityPackagesMapped]);

  const handleOpen = (newName: string) => {
    setSelectedPackageName(newName);
  };

  const activePackeges = useMemo(() => {
    if (selectOption.value === "individual-entrepreneur") {
      return fopPackagesMapped.length > 0 
        ? fopPackagesMapped 
        : ALL_PACKEGES.INDIVIDUAL_ENTREPRENEUR;
    }
    return legalEntityPackagesMapped.length > 0
      ? legalEntityPackagesMapped
      : ALL_PACKEGES.LEGAL_ENTITY;
  }, [selectOption.value, fopPackagesMapped, legalEntityPackagesMapped]);

  const isLoading = selectOption.value === "individual-entrepreneur" 
    ? isLoadingFOP 
    : isLoadingLegalEntity;

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-175 xl:min-h-0 h-full">
        <div>Завантаження...</div>
      </div>
    );
  }

  return (
    <div className="flex flex-col lg:flex-row gap-3.5 lg:gap-5 min-h-175 xl:min-h-0 h-full">
      {activePackeges.map((packege) => (
        <PackegeItem
          key={packege.id}
          selectedPackageName={selectedPackageName}
          packege={packege}
          onClick={handleOpen}
        />
      ))}
    </div>
  );
};
